import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import Title from './Title';

import { EMOJIS } from './';

import styles from './index.styl';


function EmojiLoader({ theme, title }) {
  const reactionsAtoms = theme.controls.reactions;
  const emojiBarAtoms = theme.controls.reactionsEmojiBar;

  const {
    disabled: disabledAtoms,
  } = reactionsAtoms.topic;

  return (
    <div className={styles.emojiBar}>
      <style jsx>{`
        .${styles.emojiBar}
          padding ${emojiBarAtoms.const.padding}
          border-radius ${emojiBarAtoms.const.borderRadius}
          border ${emojiBarAtoms.const.border}
          box-shadow ${emojiBarAtoms.const.boxShadow}
          background ${emojiBarAtoms.const.background}

        .${styles.content}
          color ${disabledAtoms.color}
          font ${reactionsAtoms.tiny.font}
          padding ${reactionsAtoms.tiny.padding}
          gap ${reactionsAtoms.tiny.gap}
          flex-direction ${reactionsAtoms.const.orientation}

        .${styles.reactions}
          justify-content ${emojiBarAtoms.controls.alignment}
          gap ${emojiBarAtoms.controls.interitemSpacing}px
        
        .lb-skeleton
          height ${reactionsAtoms.tiny.emojiSize}px
          width ${reactionsAtoms.tiny.emojiSize}px
      `}</style>
      <Title title={title} />
      <div className={styles.reactions}>
        {EMOJIS.map(emoji => (
          <div key={emoji} className={styles.label}>
            <div className={styles.content}>
              <div className='lb-skeleton' />
              <span className={styles.count}>0</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

EmojiLoader.propTypes = {
  theme: PropTypes.object,
  title: PropTypes.string,
};


export default withTheme(EmojiLoader);
